/* unplugin-vue-components disabled */import { render } from "./ButtonDialog.vue?vue&type=template&id=20a18f26&scoped=true"
import script from "./ButtonDialog.vue?vue&type=script&lang=js"
export * from "./ButtonDialog.vue?vue&type=script&lang=js"

import "./ButtonDialog.vue?vue&type=style&index=0&id=20a18f26&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a18f26"]])

export default __exports__